import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingCartButton = ({ cartCount, onOpen, onSendWhatsApp }) => (
  <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
    {/* Quick WhatsApp order button — only shows when cart has items */}
    {cartCount > 0 && (
      <button
        data-testid="floating-whatsapp-order"
        onClick={onSendWhatsApp}
        className="flex items-center gap-2 bg-[#25D366] text-white rounded-full shadow-2xl px-5 py-3 hover:bg-[#1DA851] transition-all duration-300 hover:scale-105"
      >
        <FaWhatsapp size={18} />
        <span className="text-sm font-bold">Pedir ahora</span>
      </button>
    )}

    {/* Cart button */}
    <button
      data-testid="floating-cart-button"
      onClick={onOpen}
      aria-label="Ver carrito"
      className="bg-[#7B1F3A] text-white rounded-full shadow-2xl w-14 h-14 flex items-center justify-center hover:bg-[#63182E] hover:scale-105 transition-all duration-300 relative"
    >
      <ShoppingBag size={22} />
      {cartCount > 0 && (
        <span
          data-testid="cart-count-badge"
          className="absolute -top-1 -right-1 bg-[#D4A853] text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold"
        >
          {cartCount}
        </span>
      )}
    </button>
  </div>
);

export default FloatingCartButton;
